import React from 'react';
import { connect } from "react-redux";
import { createStyles } from '@material-ui/core/styles';
import { compose } from "recompose";
import { withStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, Slide, Typography, Button, Grid, CircularProgress} from '@material-ui/core';
import {hideTeamProductsDialog,fetchOrgGroupProducts} from "redux/org/group/action";
import Image from 'Components/Common/image.jsx';
import { withRouter } from 'react-router-dom';
import InfiniteScroll from "react-infinite-scroll-component";
import { showSnackBar } from "redux/snackbar/action";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const connectedProps = (state) => ({
    teamProductShowDialogOpen: state.orgGroup.teamProductShowDialogOpen,
    teamProductShowDialogData: state.orgGroup.teamProductShowDialogData,
    groupProducts: state.orgGroup.groupProducts,
    fetchGroupProductTotal: state.orgGroup.fetchGroupProductTotal,
    fetchGroupProductProg: state.orgGroup.fetchGroupProductProg,
    fetchGroupProductError: state.orgGroup.fetchGroupProductError,
});

const connectionActions = {
    hideTeamProductsDialog: hideTeamProductsDialog,
    fetchOrgGroupProducts: fetchOrgGroupProducts,
    showSnackBar: showSnackBar,
}


var connector = connect(connectedProps, connectionActions);

const styles = (theme) => createStyles({
    dialogContent:{
        padding: theme.spacing(6, 8) +" !important"
    },
    title: {
        color: '#282D30',
        fontSize: theme.spacing(2.9),
        marginBottom: theme.spacing(1.4),
    },

    title2: {
        color: '#282D30',
        fontSize: theme.spacing(2.4),
        marginBottom: theme.spacing(2),
        display:'block',
        fontWeight: '500'
    },

    tableSection: {
        minHeight: 200,
        maxHeight: "calc(90vh - 250px)",
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
      },

    productItem: {
      minWidth: "107px",
      maxWidth: "107px",
      borderRadius: "10px",
      border: "2px solid #eeeeee",
      margin: '0.5rem',
      '& > img': {
        width: "auto",
        height: "55px",
        maxWidth: "90%",
        objectFit: "contain",
        margin: "0 auto",
        display: "block",
      }
    },
    productHeader:{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    },
    center: {
        textAlign: "center",
        marginTop: "1rem",
    },
    productName: {
      fontSize: '0.83em',
      fontWeight: '600',
      textAlign: 'center'
    },
    noProduct: {
        textAlign: 'center',
        width: '100%',
        fontSize: '1.2rem',
        marginTop: '3rem',
    },
    arrow: {
        paddingLeft: 5
    },
    progress: {
        textAlign: 'center',
        paddingTop: 15
    },
    buttonSection: {
        display: 'flex',
        justifyContent: "end",
        marginTop: 40
    },
});

class TeamProductShowDialog extends React.Component {

    constructor(props){
        super(props);
        this.state = {
          error: '',
          page: 0,
          pageSize: 25
        }
    }

    componentDidMount(){
        console.log(this.props.teamProductShowDialogData,'teamProductShowDialogData')
    }

    componentDidUpdate(prevProps){
        if(this.props.teamProductShowDialogOpen === true && prevProps.teamProductShowDialogOpen === false) {
            this.setState({'error': '' });
            this.props.fetchOrgGroupProducts(this.props.teamProductShowDialogData.ID, 0, this.state.pageSize);
        }
        if(!this.props.fetchGroupProductProg && prevProps.fetchGroupProductProg) {
            if(this.props.fetchGroupProductError){
                this.props.showSnackBar('Failed to fetch products', "error", 3000);
            }
        }
    }

    nextFetchData = () => {
        let products = this.props.groupProducts || [];
        if(products.length !== this.props.fetchGroupProductTotal){
            this.setState({ page: this.state.page + 1 }, () => {
            this.props.fetchOrgGroupProducts(
                this.props.teamProductShowDialogData.ID,
                this.state.page,
                this.state.pageSize,
            );
            });
        }
      };


    render() {
        const classes = this.props.classes;
        let products = this.props.groupProducts || [];

        return <Dialog 
                    onClose={this.props.showTeamProductsDialog} 
                    aria-labelledby="add-upload-dialog" 
                    open={this.props.teamProductShowDialogOpen}
                    TransitionComponent={Transition}
                    disablecenterClick={true}
                    fullWidth={true}
                    maxWidth={"lg"}
                    scroll={"body"}
                    >
                    <DialogContent classes={{root:classes.dialogContent}}>
                      <div className={classes.productHeader}>
                        <Typography variant={"h6"} className={classes.title}>{this.props.teamProductShowDialogData?.Name} products</Typography>
                        {!this.props.fetchGroupProductProg && <Typography variant={"caption"} className={classes.title2}>{products.length} {products.length>1?'Products':'Product'} </Typography>}
                      </div>
                      
                      
                      <div className={classes.tableSection} id="scrollableDiv12">
                        <InfiniteScroll
                            dataLength={products.length}
                            next={this.nextFetchData}
                            style={{ display: "flex", flexDirection: "column",overflowY: "hidden", padding: '1em'}} //To put endMessage and loader to the top.
                            hasMore={true}
                            scrollableTarget="scrollableDiv12"
                        >
                             
                            {this.props.fetchGroupProductProg && this.state.page === 0 ? (
                                <div className={classes.center}>
                                <CircularProgress />
                                </div>
                            ) : (
                                <Grid container spacing={3}>
                                    {products.length> 0? products.map((product,index)=>(
                                        <Grid item className={classes.productItem} key={index}>
                                            <Image src={product.ProductLogo} alt={product.Name} />
                                            <p className={classes.productName}>
                                                {product.Name}
                                            </p>
                                        </Grid>
                                    )): <div className={classes.noProduct}>No product found</div>}  
                                </Grid> 
                            )}

                                {this.props.fetchGroupProductProg && this.state.page !== 0 &&
                                <div className={classes.center}>
                                    <CircularProgress />
                                </div>
                                }
                            </InfiniteScroll>
                        
                      </div> 
                      <div className={classes.buttonSection}>
                        <Button variant="outlined" color="secondary" className={classes.button} onClick={()=>{
                            this.props.hideTeamProductsDialog();
                            this.setState({page: 0});
                        }}>Cancel</Button>
                          &nbsp;
                          &nbsp;
                        <Button variant="contained" color="secondary" onClick={()=>{
                            this.props.hideTeamProductsDialog();
                            this.props.history.push(`/app/products/org-products?updateTeamProducts=true&teamId=${this.props.teamProductShowDialogData?.ID}`);
                            }}>
                            Add or Update Products
                        </Button>
                        
                        </div>    
                    </DialogContent>
                </Dialog>
    }
}

export default connector(compose(
    withRouter,withStyles(styles)
)(TeamProductShowDialog));